exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-16-wrapper[data-v-32a79662]{width:195px;padding-bottom:10px}.listing-img[data-v-32a79662]{width:24px;height:24px;border-radius:50%}", ""]);

// exports
